module.exports = App.SmCheckboxComponent = Em.Component.extend [
  Em.I18n.TranslateableAttributes,
  Em.I18n.TranslateableProperties
]...,
  tagName:    'label'
  classNames: [ 'sm-checkbox' ]
  classNameBindings: [ 'disabled' ]


